import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from '@domain/models';

@Component({
  selector: 'app-payment-result-duplicated',
  templateUrl: './payment-result-duplicated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentDuplicatedResultComponent {
  readonly message = input.required<Message>();
}
